export default __webpack_public_path__ + "static/media/map_alt.02e15150.svg";